import React, { useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api, { setAccessToken } from "../services/api";
import "./Otp.css";
import AccountHomeButton from "../pages/Auth/account-home-button";

const EmpOtp = () => {
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const inputRefs = useRef([]);
    const location = useLocation();
    const navigate = useNavigate();

    const handleChange = (value, index) => {
        if (isNaN(value)) return; // Only allow numbers

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Move to the next input if not the last box
        if (value !== "" && index < 5) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && otp[index] === "") {
            // Move to the previous input on backspace
            if (index > 0) inputRefs.current[index - 1].focus();
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const userId = location.state.userId;

        try {
            const otpValue = otp.join(""); // Combine all boxes into a single string
            const { data } = await api.post("/verify-emp-otp", { userId, otp: otpValue });
            setAccessToken(data.accessToken);
            alert("OTP verified successfully!");
            navigate("/emp-dashboard");
        } catch (err) {
            alert("Invalid or expired OTP.");
        }
    };

    return (
        <>
        <AccountHomeButton/>
        <div className="otp-container">
            <h2>OTP Verification</h2>
            <form onSubmit={handleSubmit}>
                <div className="otp-inputs">
                    {otp.map((value, index) => (
                        <input
                            key={index}
                            type="text"
                            maxLength="1"
                            value={value}
                            onChange={(e) => handleChange(e.target.value, index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            ref={(el) => (inputRefs.current[index] = el)}
                        />
                    ))}
                </div>
                <button type="submit">Verify</button>
            </form>
        </div>
        </>
    );
};

export default EmpOtp;
